import { colors } from '@styles/colors';

export const selectStyle = {
  width: '100%',
  padding: '1.8vh',
  borderRadius: '3vh',
  border: `2px solid ${colors.gray200}`,
  fontSize: '1.8vh',
  backgroundColor: colors.white,
  transition: 'all 0.3s ease',
  outline: 'none',
  fontFamily: 'Inter'
};